// class ajaxCart extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener(
//       "keyup",
//       (evt) => evt.code === "Escape" && this.close()
//     );
//     this.querySelector("#ajaxcart-overlay").addEventListener(
//       "click",
//       this.close.bind(this)
//     );
//     this.setHeaderCartIconAccessibility();
//   }
//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector("#ajax-cart-icon");
//     cartLink.setAttribute("role", "button");
//     cartLink.setAttribute("aria-haspopup", "dialog");
//     cartLink.addEventListener("click", (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener("keydown", (event) => {
//       if (event.code.toUpperCase() === "SPACE") {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }
//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
//       this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {
//       this.classList.add("animate", "active");
//     });
//     this.addEventListener(
//       "transitionend",
//       () => {
//         const containerToTrapFocusOn = this.classList.contains("is-empty")
//           ? this.querySelector(".cart-inner-empty")
//           : document.getElementById("ajaxcart");
//         const focusElement = this.querySelector(".drawer-inner");
//         triggerClick(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );
//   }
//   close() {
//     this.classList.remove("active");
//     triggerClickClose(this.activeElement);
//   }
//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute("role", "button");
//     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//       cartDrawerNote.setAttribute(
//         "aria-controls",
//         cartDrawerNote.nextElementSibling.id
//       );
//     }
//     cartDrawerNote.parentElement.addEventListener("keyup", escClick);
//   }
//   renderContents(parsedState) {
//     this.querySelector(".drawer-inner").classList.contains("is-empty") &&
//       this.querySelector(".drawer-inner").classList.remove("is-empty");
//     this.productId = parsedState.id;
//     this.fetchSecToInclude().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);
//       sectionElement.innerHTML = this.callSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });
//     setTimeout(() => {
//       this.querySelector("#ajaxcart-overlay").addEventListener(
//         "click",
//         this.close.bind(this)
//       );
//       this.open();
//     });
//   }
//   callSectionInnerHTML(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector).innerHTML;
//   }
//   fetchSecToInclude() {
//     return [
//       {
//         id: "ajax-cart",
//         selector: "#ajaxcart",
//       },
//       {
//         id: "ajax-cart-icon",
//       },
//     ];
//   }
//   getSectionDOM(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector);
//   }
//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }
// customElements.define("ajax-cart", ajaxCart);
// class ajaxCartPro extends CartProduct {
//   fetchSecToInclude() {
//     return [
//       {
//         id: "ajaxcart",
//         section: "ajax-cart",
//         selector: ".drawer-inner",
//       },
//       {
//         id: "ajax-cart-icon",
//         section: "ajax-cart-icon",
//         selector: ".shopify-section",
//       },
//     ];
//   }
// }

// customElements.define("cart-pro", ajaxCartPro);

class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#ajaxcart-overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.setAddToCartAccessibility(); // 🔹 new method added
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#ajax-cart-icon");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // 🔹 new method for .add-to-cart buttons
  setAddToCartAccessibility() {
    const addToCartButtons = document.querySelectorAll(".add-to-cart");
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        setTimeout(() => {
          this.open(button);
        }, 2000);
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".cart-inner-empty")
          : document.getElementById("ajaxcart");
        const focusElement = this.querySelector(".drawer-inner");
        triggerClick(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove("active");
    triggerClickClose(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.parentElement.addEventListener("keyup", escClick);
  }

  // renderContents(parsedState) {
  //   console.log("inside update ui")
  //   this.querySelector(".drawer-inner").classList.contains("is-empty") &&
  //     this.querySelector(".drawer-inner").classList.remove("is-empty");
  //   this.productId = parsedState.id;
  //   this.fetchSecToInclude().forEach((section) => {
  //     const sectionElement = section.selector
  //       ? document.querySelector(section.selector)
  //       : document.getElementById(section.id);
  //     sectionElement.innerHTML = this.callSectionInnerHTML(
  //       parsedState.sections[section.id],
  //       section.selector
  //     );
  //   });
  //   setTimeout(() => {
  //     this.querySelector("#ajaxcart-overlay").addEventListener(
  //       "click",
  //       this.close.bind(this)
  //     );
  //     this.open();
  //   });
  // }

  // new function ST

    renderContents(parsedState) {
  console.log("=== RENDER CONTENTS START ===");
  console.log("Parsed state received:", parsedState);
  console.log("Parsed state sections:", parsedState.sections);
  console.log("Parsed state id:", parsedState.id);
  
  // Remove is-empty class from cart-pro element
  const cartPro = this.querySelector("cart-pro.product-cart-items");
  console.log("Cart-pro element found:", !!cartPro);
  console.log("Cart-pro has is-empty class:", cartPro && cartPro.classList.contains("is-empty"));
  
  if (cartPro && cartPro.classList.contains("is-empty")) {
    cartPro.classList.remove("is-empty");
    console.log("✓ Removed is-empty class from cart-pro");
  } else {
    console.log("No need to remove is-empty class (not present or element not found)");
  }
  
  // Store product ID if it exists
  if (parsedState.id) {
    this.productId = parsedState.id;
    console.log("Product ID stored:", this.productId);
  } else {
    console.log("No product ID in parsed state");
  }
  
  // Update sections
  const sectionsToInclude = this.fetchSecToInclude();
  console.log("Sections to include:", sectionsToInclude);
  
  sectionsToInclude.forEach((section) => {
    console.log(`Processing section: ${section.id}`);
    
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
    
    console.log(`  - Element found:`, !!sectionElement);
    console.log(`  - Section data exists:`, !!(parsedState.sections && parsedState.sections[section.id]));
    
    // Check if sections exist in parsedState
    if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
      console.log(`  - Updating section ${section.id}...`);
      sectionElement.innerHTML = this.callSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
      console.log(`  ✓ Section ${section.id} updated`);
    } else {
      console.log(`  ✗ Cannot update section ${section.id} - missing element or data`);
    }
  });
  
  console.log("Setting timeout for overlay and open...");
  setTimeout(() => {
    const overlay = this.querySelector("#ajaxcart-overlay");
    console.log("Overlay element found:", !!overlay);
    
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
      console.log("✓ Overlay click event added");
    } else {
      console.log("✗ Overlay not found");
    }
    
    console.log("Calling this.open()...");
    this.open();
    console.log("=== RENDER CONTENTS END ===");
  });
}
  // new function end

  callSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  fetchSecToInclude() {
    return [
      {
        id: "ajax-cart",
        selector: "#ajaxcart",
      },
      {
        id: "ajax-cart-icon",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("ajax-cart", ajaxCart);


function updateCartPreviewSection(cartData = null) {
  if (cartData) {
    // You can rebuild your sticky preview using cartData.items
    const preview = document.querySelector('#cart-preview');
    if (preview) {
      preview.innerHTML = cartData.items.map(item => `
        <div class="preview-item">
          <span>${item.title}</span>
          <span>${item.quantity} × ${Shopify.formatMoney(item.price)}</span>
        </div>
      `).join('');
    }
  } else {
    fetch('/pages/cart-preview')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newPreview = doc.querySelector('#cart-preview');
        if (newPreview) {
          document.querySelector('#cart-preview').innerHTML = newPreview.innerHTML;
        }
      })
      .catch(console.error);
  }
}
